import { useQuery } from 'react-query';
import { MenusUserAPIApi } from 'api/controllers/menus-user-apiapi';
import { QueryKeys } from 'utils/queryKeys';

export const useGetOrderingDeadlinesApi = (enabled = true) =>
  useQuery(
    QueryKeys.GET_ORDERING_DEADLINES,
    () => MenusUserAPIApi.getOrderingDeadlines(),
    { enabled, staleTime: Infinity },
  );
